export default __webpack_public_path__ + "static/media/free_board_banner_v2.1e5bd0c5.png";